export enum UserRoleType {
    EmptyRole = '',
    SeriesManager = 'SERIES_MANAGER',
    ArchiveManager = 'ARCHIVE_MANAGER',
    InformationManager = 'INFORMATION_MANAGER',
    ChairmanSelectionCommittee = 'CHAIRMAN_SELECTION_COMMITTEE',
    SelectionCommitteeMember = 'SELECTION_COMMITTEE_MEMBER',
    StaffMember = 'STAFF',
    Manager = 'MANAGER',
    ApplicationManager = 'APPLICATION_MANAGER',
    Collaborator = 'COLLABORATOR',
    Integrator = 'INTEGRATOR',
    DepotManager = 'DEPOT_MANAGER',
    DepotStaff = 'DEPOT_STAFF'
}
